// import { scrollTrigger } from "../common/_scrollTrigger";
import { loadingFunc } from '../common/_loading';

export const omoiFunc = () => {
  // ローディングアニメーション
  // loadingFunc();

  /**
   * 背景の変化 */
  // {
  //   const bg1 = document.querySelector( '.p-background__type1' );
  //   const bg2 = document.querySelector( '.p-background__type2' );
  //   const bg3 = document.querySelector( '.p-background__type3' );

  //   const triggerPoint1 = document.querySelector('.p-omoi-media');
  //   const triggerPoint2 = document.querySelector('.p-omoi-gallery');
  //   const triggerPoint3 = document.querySelector('.p-omoi-menu');
  //   scrollTrigger( triggerPoint1, 50 );
  //   scrollTrigger( triggerPoint2, 50 );
  //   scrollTrigger( triggerPoint3, 77 );

  //   window.addEventListener( 'scroll', function () {
  //     if ( triggerPoint1.classList.contains('is--scrollTrigger') && ! triggerPoint2.classList.contains('is--scrollTrigger') ) {
  //       bg1.classList.remove( 'is--show' );
  //       bg2.classList.add( 'is--show' );
  //       bg3.classList.remove( 'is--show' );
  //     } else if ( triggerPoint2.classList.contains('is--scrollTrigger') && ! triggerPoint3.classList.contains('is--scrollTrigger') ) {
  //       bg1.classList.remove( 'is--show' );
  //       bg2.classList.remove( 'is--show' );
  //       bg3.classList.add( 'is--show' );
  //     } else if ( triggerPoint3.classList.contains('is--scrollTrigger') ) {
  //       bg1.classList.add( 'is--show' );
  //       bg2.classList.remove( 'is--show' );
  //       bg3.classList.remove( 'is--show' );
  //     } else {
  //       bg1.classList.add( 'is--show' );
  //       bg2.classList.remove( 'is--show' );
  //       bg3.classList.remove( 'is--show' );
  //     }
  //   } );
  // }
};
